import Actions from 'Actions';
import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import { StorytellerState } from '../StorytellerReduxState';

export interface ShareAndEmbedModalState {
  isShareAndEmbedModalOpen: boolean;
}

/* Action Creators */
export const openShareAndEmbedModal = createAction(Actions.SHARE_AND_EMBED_MODAL_OPEN);
export const closeShareAndEmbedModal = createAction(Actions.SHARE_AND_EMBED_MODAL_CLOSE);

const initialState: ShareAndEmbedModalState = { isShareAndEmbedModalOpen: false };

export const shareAndEmbedReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(openShareAndEmbedModal, (state) => {
      state.isShareAndEmbedModalOpen = true;
    })
    .addCase(closeShareAndEmbedModal, (state) => {
      state.isShareAndEmbedModalOpen = false;
    });
});

export const selectShareAndEmbed = (state: StorytellerState) => state.shareAndEmbedReducer;

export const selectIsShareAndEmbedModalOpen = createSelector(
  selectShareAndEmbed,
  (slice) => slice.isShareAndEmbedModalOpen,
);
